<consumer-report-store-form [formModel]="model"></consumer-report-store-form>